/*
 * @Descripttion :
 * @version      :
 * @Author       : ml
 * @Date         : 2020-08-03 18:49:40
 * @LastEditors  : min
 * @LastEditTime : 2021-09-13 16:26:44
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import Vant from 'vant'
import 'vant/lib/index.css'

import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})

import animated from 'animate.css' 
Vue.use(animated)

Vue.use(Vant)

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}

	if (to.name === 'openminiprogram') {
		// 跳转到直播
		location.href =
			'carwins://component?component=wxprogram&minitype=0&gid=gh_85656a03c514&path=' //carwins://component?component=wxprogram&minitype=(0 正式版 1 测试版 2 体验版)&gid=小程序原始 id&path=拉起小程序页面的路径，不填默认拉起小程序首页
	} else {
		next()
	}
})

// 页面跳转后路由回到顶部
router.afterEach(() => {
	window.scrollTo(0, 0);
})

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
